import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createRepository } from '../../redux/slices/apiSlice';
import UseToast from "../../hooks/useToast";
import useAuth from "../../hooks/useAuth";
import Select, { components } from "react-select";





const AddFolderContent = ({ onClose, currentParentId, fetchFolders, openAddBtnDialog, folderList, rootParentObj, isCommonFolder }) => {
  const dispatch = useDispatch();
  const { successToast, errorToast } = UseToast();
  const formikRef = useRef(null);
  const { isLoggedin, user } = useAuth()
  const [initialValues, setInitialValues] = useState({
    businessUnit: "",
    brand: "",
    creativeType: "",
    name: "",
    isCommonFolder: false,
  });


  const validationSchema = Yup.object().shape({
    // businessUnit: Yup.string().required("Business Unit is required"),
    // brand: Yup.string().required("Brand is required"),
    // creativeType: Yup.string().required("Creative Type is required"),
    name: Yup.string()
      .min(3, "Folder Name must be at least 3 characters")
      .max(255, "Folder Name cannot exceed 255 characters")
      .matches(/^[a-zA-Z0-9 _-]+$/, "Only alphanumeric characters, spaces, hyphens (-), and underscores (_) are allowed")
      .required("Folder Name is required"),
    
  });

  useEffect(() => {
    setInitialValues(prev => ({
      ...prev, businessUnit: "",
      brand: "",
      creativeType: "",
      name: "",
      isCommonFolder: false,
    }));
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
  }, [openAddBtnDialog]);

  const token = sessionStorage.getItem("token");
  return (


    <Formik
      initialValues={initialValues}
      innerRef={formikRef}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
         let folderUrl = "";
        const parentRecord = folderList?.result?.find(item => item._id === currentParentId);
        if (Array.isArray(folderList?.result) && !folderList?.result[0]?.parent_id) {
          folderUrl = `${parentRecord?.name || ""}/${values.name}`
        } else {
          folderUrl = `${parentRecord?.folderUrl || ""}/${values.name}`
        }

        try {
          const headers = {
            accept: "application/json",
            authorization: token,
          };
          let payload = {
            name: values.name,
            type: 'folder',
            parent_id:  currentParentId, // '67cfde5fa611c7e45caa2974',
            owner_id: user?._id, // '67bdbbb32d81f1f8da99bf15',
            tags: 'test tags',
            description: 'test description',
            folderUrl
          }
          switch (parentRecord.folderType) {
            case "head_office":
              payload.folderType = "zonal";
              break;
            case "zonal":
              payload.folderType = "regional_user";
              break;
            case "regional_user":
              payload.folderType = "franchise";
              break;
            case "franchise":
              payload.folderType = "outlet";
              break;
          }

          (values.isCommonFolder || isCommonFolder) && (payload.folderType = "common_folder"); 

          let response = await dispatch(createRepository({ payload, headers }));
          if (response?.payload?.message) {
            successToast(response?.payload?.message);
            onClose();
            fetchFolders(currentParentId);
          } else if (response?.error?.message) {
            errorToast(response?.error?.message);
          }
          // Reset form fields to initial values
        } catch (error) {
          console.error("Submission error:", error);
        } finally {
          setSubmitting(false); // Reset submitting state
        }
      }}
    >
      {({ handleSubmit }) => (
        <Form className="formBox" onSubmit={handleSubmit}>
          {/* <div className="form-group">
            <label>Business Unit</label>
            <Field as="select" name="businessUnit" className="form-control">
              <option value="">Select Business Unit</option>
              <option value="MINI">MINI</option>
              <option value="Ebux">Ebux</option>
              <option value="Startup">Startup</option>
            </Field>
            <ErrorMessage name="businessUnit" component="div" className="error-message" />
          </div>

          <div className="form-group">
            <label>Brand</label>
            <Field as="select" name="brand" className="form-control">
              <option value="">Select Brand</option>
            </Field>
            <ErrorMessage name="brand" component="div" className="error-message" />
          </div>

          <div className="form-group">
            <label>Creative Type</label>
            <Field as="select" name="creativeType" className="form-control">
              <option value="">Select Creative Type</option>
              <option value="A+">A+</option>
              <option value="B+">B+</option>
              <option value="Brand Store">Brand Store</option>
              <option value="Images">Images</option>
              <option value="Video">Video</option>
            </Field>
            <ErrorMessage name="creativeType" component="div" className="error-message" />
          </div> */}

          <div className="form-group">
            <label>Folder Name</label>
            <Field
              className="form-control"
              type="text"
              name="name"
              maxLength={255}
              placeholder="Folder Name"
            />
            <ErrorMessage name="name" component="div" className="error-message" />
          </div>
          {/* {
            !isCommonFolder && 
            <div className="form-group">
            <label>Is Common Folder?</label>
                  <Field
                                      type="checkbox"
                                      // checked={isPartAdToggled}
                                      // onChange={handlePartAdToggle}
                                      name="isCommonFolder"
                                    />
          </div>
          } */}
 
          <div className="form-group !mb-0">
            <button className="blueBtn" type="submit">Submit</button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddFolderContent;
